const ASSET_CLASS_BADGE_CLASSES: Record<string, string> = {
  multifamily: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300',
  industrial: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  office: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300',
  retail: 'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300',
  healthcare: 'bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300',
  'self-storage': 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300',
  other: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-300',
}

export function formatCentsCompact(cents: number | null): string {
  if (cents == null) return '—'
  const dollars = cents / 100
  if (dollars >= 1_000_000) return `$${(dollars / 1_000_000).toFixed(1)}M`
  if (dollars >= 1_000) return `$${(dollars / 1_000).toFixed(0)}K`
  return `$${dollars.toLocaleString('en-US')}`
}

export function formatHoldPeriodMonths(months: number | null): string {
  if (months == null) return '—'
  const years = months / 12
  return `${years % 1 === 0 ? years.toFixed(0) : years.toFixed(1)} yr${years !== 1 ? 's' : ''}`
}

export function formatReturnRange(min: number | null, max: number | null): string {
  if (min == null && max == null) return '—'
  if (min == null) return `up to ${max}%`
  if (max == null) return `${min}%+`
  if (min === max) return `${min}%`
  return `${min}–${max}%`
}

export function assetClassBadgeClass(assetClass: string | null): string {
  const key = assetClass ?? 'other'
  return ASSET_CLASS_BADGE_CLASSES[key] ?? ASSET_CLASS_BADGE_CLASSES['other']
}
